import { Button, SearchBar } from '@/components/Common';
import { DataTable } from '@/components/Ui';
import { useCampaign } from '@/components/Views/B2BFinance/useCampaign';
import CampaignDetail from './CampaignDetail/CampaignDetail';
import { Header } from '@/components/Layout/Header/Header';
import { CampaignStats } from './CampaignStats/CampaignStats';

const CampaignList = () => {
  const {
    columns,
    formattedData,
    isLoading,
    campaignDetailData,
    campaignsData,
    openCampaignModal,
    campainListlimit,
    setCampainListLimit,
    setCampainListPage,
    campaignListPage,
  } = useCampaign();

  return (
    <>
      <Header title="Publicités" />
      <CampaignStats />
      {campaignDetailData && <CampaignDetail campaign={campaignDetailData} />}
      <div className="flex items-center justify-between bg-[#232323] py-4 px-7 rounded-[8px]">
        <SearchBar
          type="text"
          maxLength={9}
          placeholder="Recherchez une entreprise"
          className="!w-[400px]"
        />
        <Button
          title="Campagne"
          className="w-[149px] h-[41px]"
          onClick={openCampaignModal}
        />
      </div>
      <DataTable
        columns={columns}
        value={formattedData || []}
        loading={isLoading}
        withPaginator={true}
        listlimit={campainListlimit}
        limitHandler={setCampainListLimit}
        currentPageHandler={setCampainListPage}
        currentPage={campaignListPage}
        countTotal={campaignsData?.total}
      />
      ;
    </>
  );
};

export default CampaignList;
